import text from '@/text';
import { _2dMapQuoteTypes } from '@larki/shared/type/order.v2';

export const getGroupText = (group: _2dMapQuoteTypes['group']) => {
  switch (group) {
    case 'data_in_database':
      return text('buyNow3dDataInDatabase');
    case 'capture_services':
      return text('getQuote3dScanCaptureServices');
    case 'add_ons':
      return text('addOns');
    case 'membership':
      return text('membership');
    default:
      return text('unknown');
  }
};

export const getProductName = (product: _2dMapQuoteTypes['product']) => {
  switch (product) {
    case 'aerial':
      return text('aerial3D');
    case 'bim_exterior':
      return text('bim_exterior');
    case 'bim_interior':
      return text('bim_interior');
    case 'drone':
      return text('drone3D');
    case 'exterior':
      return text('exterior3D');
    case 'interior':
      return text('interior3D');
    case 'streetscape':
      return text('streetscape3D');
    case 'twod_plan_exterior':
      return text('twod_plan_exterior');
    case 'twod_plan_interior':
      return text('twod_plan_interior');
    case 'essentials_monthly':
      return text('essentialsMembershipMonthly');
    case 'essentials_yearly':
      return text('essentialsMembershipYearly');
    case 'unknown':
      return text('unknown');
  }
};
